import i18n, { I18NProps } from "@customer-tools-web/component-i18n";
import { Loading as UILoading } from "@customer-tools-web/component-ui";
import { isEmpty } from "lodash";
import * as React from "react";
import styled, { css } from "styled-components";
type ChildFunction = () => React.ReactNode;

type DataContainerProps = {
  loading: boolean;
  refetch?: () => void;
  isListingContainer?: boolean;
  data?: object;
  className?: string;
  loadingHeight?: number;
  children?: React.ReactNode | ChildFunction;
} & I18NProps;

class DataContainer extends React.Component<DataContainerProps> {
  componentDidUpdate(prevProps: Readonly<DataContainerProps>) {
    if (this.props.refetch && this.props.locale !== prevProps.locale) {
      this.props.refetch();
    }
  }

  /**
   * To fix the data cache issue.
   * refetch fresh listinsg always regardless
   */
  componentDidMount() {
    if (this.props?.refetch && this.props?.isListingContainer) {
      this.props.refetch();
    }
  }

  render() {
    const { data, loading, className, loadingHeight } = this.props;
    if (data ? isEmpty(data) : loading) {
      return <Loading className={className} height={loadingHeight} />;
    } else {
      if (this.props.children) {
        if (typeof this.props.children === "function") {
          return (this.props.children as ChildFunction)();
        } else {
          return this.props.children;
        }
      }
    }
    return null;
  }
}

export default i18n(DataContainer);
export { DataContainer, Loading };

const Loading = styled(UILoading)<{ height?: number }>`
  margin-top: 120px;
  margin-bottom: 120px;
  ${({ height }) =>
    height &&
    css`
      height: ${height}px;
    `}
`;
